// vendors
import React, { useEffect } from 'react';
import Modal from 'react-modal';

// components
import MbPdfRenderer from '../mb-pdf-renderer/mb-pdf-renderer';
import MbHeaderPdfViewerHybrid from '../mb-header-pdf-viewer-hybrid/mb-header-pdf-viewer-hybrid';

export const Z_INDEX = 10002;

export const viewportWidth = () => {
  let element = window,
    device = 'inner';
  if (!('innerWidth' in window)) {
    device = 'client';
    element = document.documentElement || document.body;
  }
  return element[device + 'Width'];
};

export const IMG_DOCUMENTATION_SUPPORTED_FORMAT = {
  PNG: '.png',
  JPG: '.jpg',
};

export const PDF_DOCUMENTATION_FORMAT = '.pdf';

const imgSupportedFormats = Object.values(IMG_DOCUMENTATION_SUPPORTED_FORMAT);

const customStyles = {
  content: {
    'position': 'absolute',
    'top': '50%',
    'left': '50%',
    'transform': 'translate(-50%, -50%)',
    'width': '100%',
    'height': '100%',
    'overflow-x': 'hidden',
    'background-color': 'white',
    'padding': 0,
  },
};
export function MbPdfHybrid({
  isOpen,
  file,
  filetype,
  fileExtension,
  filename,
  title,
  onClose,
  linkText,
}) {
  useEffect(() => {
    Modal.setAppElement('body');
  }, []);

  const renderDocument = () => {
    if (!fileExtension || fileExtension === PDF_DOCUMENTATION_FORMAT) {
      return <MbPdfRenderer file={file} fileFormat={filetype} width={viewportWidth()} />;
    } else if (imgSupportedFormats.includes(fileExtension)) {
      return <img style={{ width: '100%' }} src={file} alt={title} />;
    } else {
      return null;
    }
  };

  return (
    <Modal
      fullscreen
      isOpen={isOpen}
      style={{
        overlay: {
          zIndex: Z_INDEX,
        },
        ...customStyles,
      }}
    >
      <MbHeaderPdfViewerHybrid handleClickButton={onClose} linkText={linkText} title={title} />
      {renderDocument()}
    </Modal>
  );
}

export default MbPdfHybrid;
